export function productCardDestination(swatch) {
  return swatch.getAttribute('href') || swatch.href;
}

let ProductCard;

if (typeof HTMLElement !== 'undefined') ProductCard = class ProductCard extends HTMLElement {
  connectedCallback() {
    this.disconnect();
    this.abortController = new AbortController();
    this.primaryLink = this.querySelector('[data-product-card-primary]');
    this.personalizeLink = this.querySelector('[data-product-card-personalize]');
    this.price = this.querySelector('[data-product-card-price]');
    this.media = this.querySelector('.product-card-media');
    if (!this.primaryLink || !this.personalizeLink) return;

    const { signal } = this.abortController;
    this.addEventListener('click', event => this.handleSwatchClick(event), { signal });
    this.addEventListener('keydown', event => this.handleSwatchKeydown(event), { signal });
  }

  disconnectedCallback() { this.disconnect(); }

  disconnect() {
    this.abortController?.abort();
    this.abortController = null;
  }

  swatchFrom(event) {
    const target = event.target?.closest ? event.target : null;
    const swatch = target?.closest('[data-product-card-swatch]');
    return swatch?.tagName === 'A' && this.contains(swatch) ? swatch : null;
  }

  handleSwatchClick(event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const swatch = this.swatchFrom(event);
    if (!swatch) return;
    event.preventDefault();
    this.select(swatch);
  }

  handleSwatchKeydown(event) {
    if (event.key !== ' ') return;
    const swatch = this.swatchFrom(event);
    if (!swatch) return;
    event.preventDefault();
    this.select(swatch);
  }

  select(swatch) {
    const variantId = swatch.dataset.productCardVariantId;
    const template = [...this.querySelectorAll('[data-product-card-media-template]')]
      .find(candidate => candidate.dataset.productCardMediaTemplate === variantId);
    const nextMedia = template?.content?.firstElementChild?.cloneNode(true);
    if (!(nextMedia instanceof HTMLElement)) return;

    this.restoreDeferredImage(nextMedia);
    this.media?.replaceWith(nextMedia);
    this.media = nextMedia;
    const destination = productCardDestination(swatch);
    this.primaryLink.setAttribute('href', destination);
    this.personalizeLink.setAttribute('href', destination);
    for (const link of this.querySelectorAll('[data-product-card-link]')) link.setAttribute('href', destination);
    const colorName = this.querySelector('[data-product-card-color-name]');
    if (colorName && swatch.dataset.productCardColor) colorName.textContent = swatch.dataset.productCardColor;
    if (this.price && swatch.dataset.productCardPrice) this.price.textContent = swatch.dataset.productCardPrice;
    // A color with its own Product page heading names the card while it is picked (owner, 1 Nov 2026).
    const name = this.querySelector('[data-product-card-name]');
    if (name) name.textContent = swatch.dataset.productCardHeading || name.dataset.productCardName;
    for (const item of this.querySelectorAll('[data-product-card-swatch]')) {
      item.removeAttribute('aria-current');
      item.removeAttribute('data-selected');
    }
    swatch.setAttribute('aria-current', 'true');
    swatch.setAttribute('data-selected', '');
  }

  restoreDeferredImage(media) {
    const image = media.querySelector('img');
    if (image?.tagName !== 'IMG') return;
    const previous = this.media?.querySelector('img');
    const sizes = previous?.getAttribute('sizes') || image.dataset.productCardInitialSizes;
    if (sizes) image.setAttribute('sizes', sizes);
    if (image.dataset.productCardSrcset) image.setAttribute('srcset', image.dataset.productCardSrcset);
    if (image.dataset.productCardSrc) image.setAttribute('src', image.dataset.productCardSrc);
  }
};

if (ProductCard && !customElements.get('fl-product-card')) {
  customElements.define('fl-product-card', ProductCard);
}
